<template>
	<div class="absolute right-3 top-2 z-20 flex flex-row gap-2">
		<ion-button
			class="text-base"
			size="small"
			color="medium"
			:title="$t('main-map.options')"
			@click="isOptionsModalOpen = true"
		>
			<ion-icon slot="icon-only" :icon="settingsOutline" />
		</ion-button>
		<ion-button
			class="text-base"
			size="small"
			title="Center map on lots"
			@click="emit('centerMap')"
		>
			{{ $t("main-map.center") }}
		</ion-button>
		<div class="rounded-lg bg-gray-100 px-3">
			<ion-select v-model="styleSelection" interface="popover">
				<ion-select-option
					v-for="style in mapboxStyles"
					:key="style.id"
					:value="style.id"
				>
					{{ style.label }}
				</ion-select-option>
			</ion-select>
		</div>

		<MainMapOptionsModal
			v-model="isOptionsModalOpen"
			v-model:show-regions="showRegions"
		/>
	</div>
</template>

<script setup lang="ts">
	import { IonSelect, IonSelectOption, IonButton, IonIcon } from "@ionic/vue";
	import { settingsOutline } from "ionicons/icons";
	import { mapboxStyles } from "@/composables/map/useMapStyles";
	import MainMapOptionsModal from "@/views/MainMap/MainMapOptionsModal.vue";
	import { ref } from "vue";

	const emit = defineEmits<{
		centerMap: [];
	}>();

	const styleSelection = defineModel<string>("styleSelection");
	const showRegions = defineModel<boolean>("showRegions");

	const isOptionsModalOpen = ref(false);
</script>
